import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import { API_BASE_URL } from "../../config/api";
import { Menu } from "lucide-react";




const pagesList = [
  "dashboard",
  "products",
  "parts",
  "orders",
  "sales",
  "repairs",
  "analysis",
  "expenses",
  "device-purchases",
];



const AdminSettings = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("authToken");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isAdmin = user?.role === "admin";

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [permissions, setPermissions] = useState([]);

  const [createForm, setCreateForm] = useState({
    username: "",
    password: "",
    role: "user",
  });

  const [editForm, setEditForm] = useState({
    username: "",
    password: "",
  });

  // ================= FETCH USERS =================
  const fetchUsers = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) throw new Error("Failed to fetch users");

      const data = await res.json();
      setUsers(data || []);
    } catch (err) {
      console.error("Fetch users error:", err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // ================= CREATE USER =================
  const createUser = async () => {
    if (!createForm.username || !createForm.password) {
      return alert("Username & password required");
    }

    try {
      const res = await fetch(`${API_BASE_URL}/api/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(createForm),
      });

      if (!res.ok) throw new Error("Failed to create user");

      setCreateForm({ username: "", password: "", role: "user" });
      fetchUsers();
    } catch (err) {
      console.error("Create user error:", err);
    }
  };

  // ================= DELETE USER =================
  const deleteUser = async (id) => {
    if (!window.confirm("Delete user?")) return;

    try {
      const res = await fetch(`${API_BASE_URL}/api/users/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) throw new Error("Delete failed");

      fetchUsers();
      if (selectedUser?.id === id) setSelectedUser(null);
    } catch (err) {
      console.error("Delete user error:", err);
    }
  };

  // ================= OPEN USER =================
  const openUser = async (u) => {
    setSelectedUser(u);
    setEditForm({ username: u.username, password: "" });

    try {
      const res = await fetch(
        `${API_BASE_URL}/api/users/${u.id}/permissions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.ok) throw new Error("Permissions fetch failed");

      const perms = await res.json();
      setPermissions(perms || []);
    } catch (err) {
      console.error("Permissions error:", err);
      setPermissions([]);
    }
  };

  // ================= SAVE USER =================
  const saveUser = async () => {
    if (!selectedUser) return;

    try {
      const res = await fetch(
        `${API_BASE_URL}/api/users/${selectedUser.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(editForm),
        }
      );

      if (!res.ok) throw new Error("Save failed");

      fetchUsers();
    } catch (err) {
      console.error("Save user error:", err);
    }
  };

  // ================= PERMISSIONS =================
  const togglePage = (page) => {
    setPermissions((prev) =>
      prev.includes(page)
        ? prev.filter((p) => p !== page)
        : [...prev, page]
    );
  };

  const savePermissions = async () => {
    if (!selectedUser) return;

    try {
      const res = await fetch(
        `${API_BASE_URL}/api/users/${selectedUser.id}/permissions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ pages: permissions }),
        }
      );

      if (!res.ok) throw new Error("Save permissions failed");

      alert("Permissions updated");
      fetchUsers();
    } catch (err) {
      console.error("Save permissions error:", err);
    }
  };

 return (
  <div className="min-h-screen overflow-x-hidden bg-gray-50 text-gray-800">
    <Sidebar
      isOpen={sidebarOpen}
      onClose={() => setSidebarOpen(false)}
    />

    {/* HAMBURGER - VETËM MOBILE */}
    <button
      type="button"
      onClick={() => setSidebarOpen(true)}
      className="
        fixed
        left-4
        top-4
        z-30
        flex
        h-11
        w-11
        items-center
        justify-center
        rounded-xl
        bg-blue-700
        text-white
        shadow-lg
        transition-all
        duration-200
        ease-out
        hover:bg-blue-800
        active:scale-95
        lg:hidden
      "
      aria-label="Hap menunë"
    >
      <Menu size={24} />
    </button>

    <main
      className="
        min-h-screen
        min-w-0
        overflow-x-hidden
        px-4
        pb-8
        pt-20

        sm:px-6

        lg:ml-64
        lg:w-[calc(100%-16rem)]
        lg:overflow-visible
        lg:p-10
      "
    >
      {/* HEADER */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold sm:text-3xl">
          Admin Settings
        </h1>

        <p className="mt-1 text-sm text-gray-500 sm:text-base">
          Logged in as{" "}
          <span className="font-semibold text-blue-600">
            {user?.username}
          </span>
        </p>
      </div>

      {isAdmin && (
        <div className="space-y-6">
          {/* CREATE USER */}
          <section
            className="
              rounded-2xl
              bg-white
              p-4
              shadow-sm

              sm:p-6
            "
          >
            <h2 className="mb-4 text-lg font-bold">
              Create User
            </h2>

            <div className="space-y-3">
              <input
                type="text"
                placeholder="Username"
                value={createForm.username}
                onChange={(e) =>
                  setCreateForm({
                    ...createForm,
                    username: e.target.value,
                  })
                }
                className="
                  w-full
                  rounded-lg
                  border
                  border-gray-300
                  bg-white
                  px-3
                  py-2.5
                  outline-none
                  transition
                  focus:border-blue-500
                  focus:ring-2
                  focus:ring-blue-100
                "
              />

              <input
                type="password"
                placeholder="Password"
                value={createForm.password}
                onChange={(e) =>
                  setCreateForm({
                    ...createForm,
                    password: e.target.value,
                  })
                }
                className="
                  w-full
                  rounded-lg
                  border
                  border-gray-300
                  bg-white
                  px-3
                  py-2.5
                  outline-none
                  transition
                  focus:border-blue-500
                  focus:ring-2
                  focus:ring-blue-100
                "
              />

              <select
                value={createForm.role}
                onChange={(e) =>
                  setCreateForm({
                    ...createForm,
                    role: e.target.value,
                  })
                }
                className="
                  w-full
                  rounded-lg
                  border
                  border-gray-300
                  bg-white
                  px-3
                  py-2.5
                  outline-none
                  transition
                  focus:border-blue-500
                  focus:ring-2
                  focus:ring-blue-100
                "
              >
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </select>

              <button
                type="button"
                onClick={createUser}
                className="
                  w-full
                  rounded-lg
                  bg-blue-600
                  px-4
                  py-2.5
                  font-medium
                  text-white
                  shadow-sm
                  transition
                  hover:bg-blue-700
                  active:scale-[0.98]

                  sm:w-auto
                "
              >
                Create
              </button>
            </div>
          </section>

          {/* USERS LIST */}
          <section
            className="
              rounded-2xl
              bg-white
              p-4
              shadow-sm

              sm:p-6
            "
          >
            <div className="mb-4 flex items-center justify-between gap-3">
              <h2 className="text-lg font-bold">
                Users
              </h2>

              <span
                className="
                  rounded-full
                  bg-blue-50
                  px-3
                  py-1
                  text-xs
                  font-medium
                  text-blue-700
                "
              >
                {users.length}
              </span>
            </div>

            {users.length === 0 ? (
              <div
                className="
                  rounded-xl
                  border
                  border-dashed
                  border-gray-300
                  px-4
                  py-10
                  text-center
                  text-gray-500
                "
              >
                No users found
              </div>
            ) : (
              <div className="space-y-3">
                {users.map((u) => (
                  <div
                    key={u.id}
                    className="
                      flex
                      flex-col
                      gap-4
                      rounded-xl
                      border
                      border-gray-200
                      p-4
                      transition
                      hover:border-blue-200
                      hover:bg-blue-50/30

                      sm:flex-row
                      sm:items-center
                      sm:justify-between
                    "
                  >
                    <div className="min-w-0">
                      <div className="truncate font-semibold">
                        {u.username}
                      </div>

                      <div className="mt-1 text-sm capitalize text-gray-500">
                        {u.role}
                      </div>
                    </div>

                    <div
                      className="
                        grid
                        grid-cols-2
                        gap-2

                        sm:flex
                        sm:items-center
                      "
                    >
                      <button
                        type="button"
                        onClick={() => openUser(u)}
                        className="
                          rounded-lg
                          bg-blue-50
                          px-4
                          py-2
                          text-sm
                          font-medium
                          text-blue-700
                          transition
                          hover:bg-blue-100
                          active:scale-[0.98]
                        "
                      >
                        Edit
                      </button>

                      <button
                        type="button"
                        onClick={() => deleteUser(u.id)}
                        className="
                          rounded-lg
                          bg-red-50
                          px-4
                          py-2
                          text-sm
                          font-medium
                          text-red-600
                          transition
                          hover:bg-red-100
                          active:scale-[0.98]
                        "
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </section>

          {/* EDIT USER */}
          {selectedUser && (
            <section
              className="
                rounded-2xl
                bg-white
                p-4
                shadow-sm

                sm:p-6
              "
            >
              <div className="mb-5">
                <h2 className="text-lg font-bold">
                  Edit {selectedUser.username}
                </h2>

                <p className="mt-1 text-sm text-gray-500">
                  Update account details and page permissions.
                </p>
              </div>

              <div className="space-y-3">
                <input
                  type="text"
                  value={editForm.username}
                  onChange={(e) =>
                    setEditForm({
                      ...editForm,
                      username: e.target.value,
                    })
                  }
                  className="
                    w-full
                    rounded-lg
                    border
                    border-gray-300
                    bg-white
                    px-3
                    py-2.5
                    outline-none
                    transition
                    focus:border-blue-500
                    focus:ring-2
                    focus:ring-blue-100
                  "
                />

                <input
                  type="password"
                  placeholder="New Password"
                  value={editForm.password || ""}
                  onChange={(e) =>
                    setEditForm({
                      ...editForm,
                      password: e.target.value,
                    })
                  }
                  className="
                    w-full
                    rounded-lg
                    border
                    border-gray-300
                    bg-white
                    px-3
                    py-2.5
                    outline-none
                    transition
                    focus:border-blue-500
                    focus:ring-2
                    focus:ring-blue-100
                  "
                />

                <button
                  type="button"
                  onClick={saveUser}
                  className="
                    w-full
                    rounded-lg
                    bg-green-600
                    px-4
                    py-2.5
                    font-medium
                    text-white
                    transition
                    hover:bg-green-700
                    active:scale-[0.98]

                    sm:w-auto
                  "
                >
                  Save User
                </button>
              </div>

              <div className="my-6 h-px bg-gray-200" />

              <h3 className="mb-3 font-semibold">
                Permissions
              </h3>

              <div
                className="
                  mb-5
                  grid
                  grid-cols-1
                  gap-2

                  min-[420px]:grid-cols-2

                  md:grid-cols-3
                "
              >
                {pagesList.map((page) => (
                  <label
                    key={page}
                    className="
                      flex
                      cursor-pointer
                      items-center
                      gap-3
                      rounded-lg
                      border
                      border-gray-200
                      px-3
                      py-2.5
                      text-sm
                      transition
                      hover:border-blue-300
                      hover:bg-blue-50
                    "
                  >
                    <input
                      type="checkbox"
                      checked={permissions.includes(page)}
                      onChange={() => togglePage(page)}
                      className="
                        h-4
                        w-4
                        cursor-pointer
                        accent-blue-600
                      "
                    />

                    <span className="truncate">
                      {page}
                    </span>
                  </label>
                ))}
              </div>

              <button
                type="button"
                onClick={savePermissions}
                className="
                  w-full
                  rounded-lg
                  bg-blue-600
                  px-4
                  py-2.5
                  font-medium
                  text-white
                  transition
                  hover:bg-blue-700
                  active:scale-[0.98]

                  sm:w-auto
                "
              >
                Save Permissions
              </button>
            </section>
          )}
        </div>
      )}

      {!isAdmin && (
        <div
          className="
            rounded-2xl
            border
            border-red-200
            bg-red-50
            px-4
            py-10
            text-center
            text-red-600
          "
        >
          You do not have permission to access Admin Settings.
        </div>
      )}
    </main>
  </div>
);
};

export default AdminSettings;